export default "__VITE_ASSET__BCTU1d0s__"